<template>
    <div class='kbdjs' v-if='kbxmlc'>
        <div class='box'>
            <h2>距离<span>{{endTime}}</span>开标倒计时</h2>
            <myClock :shenyu='shenyu' v-if='shenyu' cId='c1'></myClock>
            <el-button type="primary" @click='nextBtn' :disabled="kbxmlc.zt==2 || !isNext" v-if='role=="Z"'>下一步</el-button>
        </div>
    </div>
    <div v-else class='loading'>
        <p>页面正在加载中...</p>
        <div id="colorfulPulse">
            <span class='item-1'></span>
            <span class='item-2'></span>
            <span class='item-3'></span>
            <span class='item-4'></span>
            <span class='item-5'></span>
            <span class='item-6'></span>
            <span class='item-7'></span>
        </div>
    </div>
</template>
<script>
import myClock from '../components/clock/clock'
export default {
    name:'kbdjs',
    components:{
        myClock
    },
    computed:{
        isNext() {
            return this.kbsj? this.kbsj<= new Date().getTime():false
        }
    },
    data(){
        return{
            waitLoading:false,
            djlcId:'',//节点流程id
            kbxmlc:'',
            endTime:'',//开标时间
            shenyu:'',
            role:localStorage.getItem('role')?localStorage.getItem('role'):'T',
            kbsj:'' // 用于判断是否可以点下一步
        }
    },
    methods: {
        getData(){
            let para={
                djlcId:this.djlcId,
            }
            this.waitLoading=true
            this.$api.kbqdList(para).then(res=>{
                if(res.data.meta.success){
                    this.kbxmlc=res.data.data.kbxmlc
                    var time=new Date(res.data.data.kbsj);
                    setTimeout(() => {
                        this.kbsj = null // 先赋值null 触发计算属性
                        this.kbsj = new Date(time).getTime()
                    }, 1000)
                    var h=time.getHours()>=10?time.getHours():'0'+time.getHours();
                    var m=time.getMinutes()>=10?time.getMinutes():'0'+time.getMinutes();
                    var s=time.getSeconds()>=10?time.getSeconds():'0'+time.getSeconds();
                    this.shenyu=res.data.data.djs;
                    if(this.shenyu > 0){
                        this.isKb()
                    }
                    this.endTime=h+":"+m+":"+s;
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
                this.waitLoading=false
            }).catch(()=>{})
        },
        nextBtn(){
            let para={
                flag:this.kbxmlc.ycdz
            }
            this.waitLoading=true
            this.$emit('nextBtn',para)
        },        
        isKb() {
            var _this=this;
            clearInterval(_this.intervalKb);
            _this.intervalKb=null;
            this.intervalKb=setInterval(function(){
                if (_this.shenyu < 1000) {
                    clearInterval(_this.intervalKb);
                    _this.intervalKb=null;
                    _this.getData()
                    return;
                }
                _this.shenyu=_this.shenyu-1000;
            },1000)
        }, 
        againTime() {
            var bowhidden="hidden" in document?"hidden": "webkithidden" in document?"webkithidden": "mozhidden" in document ?"mozhidden": null;
            var vibchage="visibilitychange" || "webkitvisibilitychange" || "mozvisibilitychange";
            document.addEventListener(vibchage,()=> {
                if(!document[bowhidden]) /*false*/
                {
                    this.getData();
                }
            });
        },
        checkViChange(){
            if(!document.hidden){
                //如果浏览器处于禁止状态，则重新获取数据
                this.getData();
            }
        },
        
    },
    mounted(){
        this.djlcId=this.$route.query.djlcId;
        this.getData();
        let _this=this;
        document.addEventListener("visibilitychange", _this.checkViChange);
        this.againTime()
    },
    beforeDestroy(){
        clearInterval(this.intervalKb);
        this.intervalKb=null;
        document.removeEventListener("visibilitychange",this.checkViChange)
    }
}
</script>
<style lang="less" scope>
    div.kbdjs>.box{
        background:#fdf0f3;
        border-color:@border-color;
        border-top:2px solid @base-color;
        height:100%;
        text-align: center;
        padding-top:80px;
        display: flex;
        flex-direction: column;
        align-items: center;
        h2{
            font-size: 36px;
        }
        .el-button{
            width:350px;
            height:55px;
            line-height:55px;
            font-size: 20px;
        }
    }
    .kbdjs .errorMsg{
        height: 30px;
        margin-left:70px;
        p{
            background:url('../assets/images/error.jpg') no-repeat 10px center;
            color:@base-color;
            font-size: 12px;
            padding-left:30px;
        }
    }
   .el-input-group__append button.el-button{
       min-width:40px;
   }
</style>